export const CAN_RESET_USER_PASSSWORD = 'CanResetUserPassword';
